export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-zoom/src/constant.js
// module id = 481
// module chunks = 0 1 2 3 4